











import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class TextField extends Vue {
    @Prop() private value!: string;
    @Prop({default: ""}) private placeholder!: string;
    @Prop({default:100}) private maxLength!:number;

    get textValue() {
        return this.value;
    }

    set textValue(value: string) {
        this.$emit("change", value);
    }
}
